import api from "utils/api";

export const apiGetOrganisationCampaigns = (data) => {
  const { organisationId } = data;

  const apiRoute = `/email/organisation/${organisationId}/campaign`;

  return api.get(apiRoute);
};
